window.app_models.property_list = [
    window.app_models.property
];


// WEBPACK FOOTER //
// ./resources/assets/js/models/property_list.js